import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import juniperUserMixin from '../mixins/juniperUserMixin'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	routes, // short for `routes: routes`
})

/* router.onError(error => {
	console.error(error)
	Vue.prototype.$log.error('Failure Reason: ', error.message, error)
	if (/ChunkLoadError:.*failed./i.test(error.message)) {
		Vue.prototype.$log.error('Reloading Window 1')
		window.location.reload()
	} else if (/Loading.*chunk.*failed./i.test(error.message)) {
		Vue.prototype.$log.error('Reloading Window 2')
		window.location.reload()
	}
}) */

router.beforeEach((to, from, next) => {
	// If Juniper user hasn't been loaded yet, allow navigation
	// The component's API calls will trigger Juniper auth via the 401 interceptor
	// const juniperUser = juniperUserMixin.methods.getCurrentUser();
	// if (!juniperUser) {
	// 	next();
	// 	return;
	// }

	if (to.meta.permissionsAll) {
		const permissions = to.meta.permissionsAll
		if (!juniperUserMixin.methods.userHasAllNeededJuniperPermissions(permissions)) {
			next({ name: 'Page403', params: { pathMatch: to.fullPath } })
			return
		}
	}

	if (to.meta.permissionsOne) {
		const permissions = to.meta.permissionsOne
		if (!juniperUserMixin.methods.userHasOneOfNeededJuniperPermissions(permissions)) {
			next({ name: 'Page403', params: { pathMatch: to.fullPath } })
			return
		}
	}

	next()
})

export default router
